import Card from '@mui/material/Card'
import { Formik, FormikHelpers } from 'formik'
import { FC } from 'react'
import * as Yup from 'yup'

import FormComponent from 'components/forms/elements/Form'
import FormButton from 'components/forms/elements/FormButton'
import FormButtonContainer from 'components/forms/elements/FormButtonContainer'
import FormGrid from 'components/forms/elements/FormGrid'
import { Event, FormEvent } from 'models/API'

import content from './content'
import schema from './schema'

interface Props {
  events: Array<Event | FormEvent>
  onSubmit: (values: Yup.InferType<typeof schema>) => Promise<void>
}
type FormValues = Yup.InferType<typeof schema>

const Form: FC<Props> = ({ events, onSubmit }) => {
  const handleSubmit = async (
    values: FormValues,
    actions: FormikHelpers<FormValues>,
  ) => {
    await onSubmit(values)
    actions.setSubmitting(false)
  }

  return (
    <>
      {events && (
        <Formik
          initialValues={{ eventId: null, email: null }}
          validateOnMount={true}
          enableReinitialize
          validationSchema={schema}
          onSubmit={handleSubmit}>
          {(form) => {
            const updateField = (key: string, value: string) => {
              form.setFieldValue(key, value)
            }
            return (
              <FormComponent>
                <Card>
                  <FormGrid
                    content={content({
                      events,
                      formDisabled: form.isSubmitting,
                      updateField,
                    })}
                  />
                  <FormButtonContainer wrap={false} my={3} mx={3}>
                    <></>
                    <FormButton
                      submit
                      primary
                      outlined
                      disabled={!form.isValid || form.isSubmitting}
                      loading={form.isSubmitting}>
                      Search
                    </FormButton>
                  </FormButtonContainer>
                </Card>
              </FormComponent>
            )
          }}
        </Formik>
      )}
    </>
  )
}

export default Form
